import React from "react";
import PropTypes from "prop-types";
import { ButtonGroup, Button } from "@material-ui/core";
import { useSelectedTheme } from "../../../Hooks";

// styles
import useStyles from "./styles";

function CustomViewModeSwitcher({
  modes,
  selectedMode,
  onChangeMode,
  isLoading,
  buttonGroupProps,
  buttonProps,
}) {
  const styles = useStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();

  return (
    <ButtonGroup
      disabled={isLoading}
      className={styles.viewModeBtnGroup}
      size="small"
      disableRipple
      {...buttonGroupProps}
    >
      {modes.map((mode) => (
        <Button
          key={mode.value}
          className={selectedMode === mode.value ? styles.isActiveBg : ""}
          onClick={() => onChangeMode(mode.value)}
          style={{ display: "flex", alignItems: "center" }}
          {...buttonProps}
        >
          {mode.icon}
          {mode.label && (
            <span
              style={{
                marginLeft: 6,
                color: palette.text.secondary,
                fontWeight: 600,
                fontSize: 14,
                display: "inline-block",
                verticalAlign: "middle",
              }}
            >
              {mode.label}
            </span>
          )}
        </Button>
      ))}
    </ButtonGroup>
  );
}

CustomViewModeSwitcher.propTypes = {
  modes: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      icon: PropTypes.element.isRequired,
      label: PropTypes.node,
    })
  ).isRequired,
  selectedMode: PropTypes.string.isRequired,
  onChangeMode: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  buttonGroupProps: PropTypes.object,
  buttonProps: PropTypes.object,
};

CustomViewModeSwitcher.defaultProps = {
  isLoading: false,
  buttonGroupProps: {},
  buttonProps: {},
};

export default CustomViewModeSwitcher;
